/**
 * Created by zhangrp on 2018/4/3.
 */

import {Utils} from '../../app.base';
import {MsgBox, Vue} from '../../app.vues';
import {getUserScopeEntity} from "../index";
import devcApi from '../../api/devc';
import comnApi from '../../api/comn'

import SwbShopDevcImpItemList from './ShopDevcImpItemList';
import SwbShopDeviceFormatExpl from '../retailer/ShopDeviceFormatExpl';
import SwbShopDevcImpDevcCheck from './ShopDevcImpDevcCheck';
import SwbShopDevcImpAssetCheck from './ShopDevcImpAssetCheck';

Vue.regist(SwbShopDevcImpItemList);
Vue.regist(SwbShopDeviceFormatExpl);
Vue.regist(SwbShopDevcImpDevcCheck);
Vue.regist(SwbShopDevcImpAssetCheck);

//机构设备导入详细列表
export function openShopDeviceImpItemListDlg(params, callback) {
    let recId = params['recId'] || null;
    let deviceFlag = params["deviceFlag"];
    let theDlg = Vue.$showDialog({
        title: Utils.isTrue(deviceFlag) ? "机构设备导入详细列表" : "机构资产导入详细列表",
        width: "90%",
        height: "90%",
        okVisible: false,
        showCloseBtn: true,
        cancelText: '关闭',
        template: '<swb-shop-devc-imp-item-list :recId="recId" :deviceFlag="deviceFlag"  ref="swb_shop_device_imp_item_list"></swb-shop-devc-imp-item-list>',
        data: {
            recId: recId,
            deviceFlag: Utils.isTrue(deviceFlag)
        },
        methods: {
            theDlgClose: function () {
                theDlg.close();
            }
        }
    });
};

//机构设备导入格式说明
export function shopDeviceFormatExplDlg(assetType, normalFlag) {
    Vue.$showDialog({
        title: "导入文件格式说明",
        width: "90%",
        height: "90%",
        okVisible: false,
        showCloseBtn: true,
        cancelText: '关闭',
        template: '<swb-shop-device-format-expl :assetType="assetType"></swb-shop-device-format-expl>',
        data: {
            assetType: assetType
        },
    });
};
// 机构资产导入检查
export function openShopDeviceImpCheckDlg(fileObj, callback) {
    let theDlg = null;
    theDlg = Vue.$showDialog({
        title: "机构资产导入检查",
        width: -100,
        height: -20,
        okVisible: false,
        cancelVisible: false,
        extVisible: true,
        showCloseBtn: true,
        okText: '整体导入',
        extText: '关闭',
        cancelText: '整体检查',
        template: '<swb-shop-devc-imp-asset-check @other-close="otherClose" :fileObj="fileObj" ref="swb_shop_device_imp_check"></swb-shop-devc-imp-asset-check>',
        data: {
            fileObj: fileObj,
        },
        methods: {
            doDeviceImpModelImport(deviceImpDto){
                let theLoading = MsgBox.loading("正在执行导入");
                devcApi.doDeviceImpModelImport(deviceImpDto, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        if (Utils.isNoB(result.data.errMsg)) {
                            callback(result.data);
                            theDlg.close();
                        } else {
                            MsgBox.warning(result.data.errMsg);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            otherClose(importRecId){
                callback({
                    importRecId: importRecId,
                    importStatis: null
                });
                theDlg.close();
            }
        },
        okClicked: function () {
            let self = this;
            let deviceImpDto = self.$refs.swb_shop_device_imp_check.getDlgResult() || {};
            // 判断全部的状态是否是ok
            if (Utils.isNoB(deviceImpDto.warehouseId)) {
                Toast.show('请选择入库仓库', 2000, 'info');
                return false;
            }
            if (!Utils.isNoB(deviceImpDto.srcVoucherType) && Utils.isNoB(deviceImpDto.srcVoucherNo)) {
                Toast.show('请输入来源单据编号', 2000, 'info');
                return false;
            }
            let deviceImpInfoList = deviceImpDto.deviceImpInfoList;
            if (deviceImpInfoList.length > 500) {
                MsgBox.warning("数据较多，请使用逐条检查导入");
                return false;
            }
            //
            let theLoading = MsgBox.loading("正在检查同源资产");
            devcApi.validateShopDeviceTitle(deviceImpDto, function (result) {
                theLoading.close();
                if (result.type == 'info') {
                    let wranMsg = result.data;
                    if (Utils.isNoB(wranMsg)) {
                        self.doDeviceImpModelImport(deviceImpDto);
                    } else {
                        wranMsg = Utils.replace(wranMsg, '\n', '<br/>');
                        let theDlg2 = Vue.$showDialog({
                            title: '提示-确认导入',
                            width: -400,
                            height: -200,
                            okText: '导入',
                            showCloseBtn: true,
                            template: '<div class="form-info">' +
                            '   <div class="form-row">' +
                            '        <div class="form-label">' +
                            '            <label></label>' +
                            '        </div>' +
                            '        <div class="form-value">' +
                            '            <span v-html="wranMsg"></span>' +
                            '        </div>' +
                            '    </div>' +
                            '</div>',
                            data: {
                                wranMsg: wranMsg
                            },
                            methods: {},
                            okClicked: function () {
                                self.doDeviceImpModelImport(deviceImpDto);
                            },
                            lifecycle: {
                                created: function () {
                                    MsgBox.warning("部分同源资产描述全称不一致,请确认");
                                }
                            }
                        });
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            });

            return false;
        },
        cancelClicked: function () {
            let self = this;
            let deviceImpDto = self.$refs.swb_shop_device_imp_check.getDlgResult() || {};
            let deviceImpInfoList = deviceImpDto.deviceImpInfoList;
            //
            if (deviceImpInfoList.length > 500) {
                MsgBox.warning("数据较多，请使用逐条检查导入");
                return false;
            }
            let theLoading = MsgBox.loading("正在检查导入数据");
            devcApi.validateDeviceImpModel(deviceImpDto, function (result) {
                theLoading.close();

                if (result.data != null) {
                    self.$refs.swb_shop_device_imp_check.dlgSetDeviceImpDto(result.data);
                }
                console.log(result);
                if (result.type != 'info') {
                    MsgBox.warning(Utils.replace(result.message || '未知错误', '\n', '<br/>'));
                } else {
                    Toast.show(result.message || '数据验证通过', 5000, 'info');
                }
            });
            return false;
        }
    });
};

import SwbShopDeviceImpDevcCheck from './ShopDevcImpDevcCheck'
Vue.regist(SwbShopDeviceImpDevcCheck);

// 机构设备导入检查
export function openShopDeviceImpDevcCheckDlg(fileObj, callback) {
    let theDlg = null;
    theDlg = Vue.$showDialog({
        title: "机构设备导入检查",
        width: -100,
        height: -20,
        okVisible: false,
        cancelVisible: false,
        extVisible: true,
        showCloseBtn: true,
        okText: '整体导入',
        extText: '关闭',
        cancelText: '整体检查',
        template: '<swb-shop-devc-imp-devc-check @other-close="otherClose" :fileObj="fileObj" ref="swb_shop_device_imp_check"></swb-shop-devc-imp-devc-check>',
        data: {
            fileObj: fileObj,
        },
        methods: {
            doDeviceImpModelImport(deviceImpDto){
                let theLoading = MsgBox.loading("正在执行导入");
                devcApi.doDeviceImpModelImport(deviceImpDto, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        if (Utils.isNoB(result.data.errMsg)) {
                            callback(result.data);
                            theDlg.close();
                        } else {
                            MsgBox.warning(result.data.errMsg);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            otherClose(importRecId){
                callback({
                    importRecId: importRecId,
                    importStatis: null
                });
                theDlg.close();
            }
        },
        okClicked: function () {
            let self = this;
            let deviceImpDto = self.$refs.swb_shop_device_imp_check.getDlgResult() || {};
            // 判断全部的状态是否是ok
            if (Utils.isNoB(deviceImpDto.warehouseId)) {
                Toast.show('请选择入库仓库', 2000, 'info');
                return false;
            }
            if (!Utils.isNoB(deviceImpDto.srcVoucherType) && Utils.isNoB(deviceImpDto.srcVoucherNo)) {
                Toast.show('请输入来源单据编号', 2000, 'info');
                return false;
            }
            let deviceImpInfoList = deviceImpDto.deviceImpInfoList;
            if (deviceImpInfoList.length > 500) {
                MsgBox.warning("数据较多，请使用逐条检查导入");
                return false;
            }
            //
            let theLoading = MsgBox.loading("正在检查同源资产");
            devcApi.validateShopDeviceTitle(deviceImpDto, function (result) {
                theLoading.close();
                if (result.type == 'info') {
                    let wranMsg = result.data;
                    if (Utils.isNoB(wranMsg)) {
                        self.doDeviceImpModelImport(deviceImpDto);
                    } else {
                        wranMsg = Utils.replace(wranMsg, '\n', '<br/>');
                        let theDlg2 = Vue.$showDialog({
                            title: '提示-确认导入',
                            width: -400,
                            height: -200,
                            okText: '导入',
                            showCloseBtn: true,
                            template: '<div class="form-info">' +
                            '   <div class="form-row">' +
                            '        <div class="form-label">' +
                            '            <label></label>' +
                            '        </div>' +
                            '        <div class="form-value">' +
                            '            <span v-html="wranMsg"></span>' +
                            '        </div>' +
                            '    </div>' +
                            '</div>',
                            data: {
                                wranMsg: wranMsg
                            },
                            methods: {},
                            okClicked: function () {
                                self.doDeviceImpModelImport(deviceImpDto);
                            },
                            lifecycle: {
                                created: function () {
                                    MsgBox.warning("部分同源资产描述全称不一致,请确认");
                                }
                            }
                        });
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            });

            return false;
        },
        cancelClicked: function () {
            let self = this;
            let deviceImpDto = self.$refs.swb_shop_device_imp_check.getDlgResult() || {};
            let deviceImpInfoList = deviceImpDto.deviceImpInfoList;
            //
            if (deviceImpInfoList.length > 500) {
                MsgBox.warning("数据较多，请使用逐条检查导入");
                return false;
            }
            let theLoading = MsgBox.loading("正在检查导入数据");
            devcApi.validateDeviceImpModel(deviceImpDto, function (result) {
                theLoading.close();

                if (result.data != null) {
                    self.$refs.swb_shop_device_imp_check.dlgSetDeviceImpDto(result.data);
                }
                console.log(result);
                if (result.type != 'info') {
                    MsgBox.warning(Utils.replace(result.message || '未知错误', '\n', '<br/>'));
                } else {
                    Toast.show(result.message || '数据验证通过', 5000, 'info');
                }
            });
            return false;
        }
    });
}

import SwbShopDeviceInfo from './ShopDeviceInfo'
Vue.regist(SwbShopDeviceInfo);
export function showShopDeviceInfo(id, showSingleTobObj, title) {
    Vue.$showDialog({
        title: title,
        showCloseBtn: true,
        cancelText: '关闭',
        okVisible: false,
        width: -100,
        height: -200,
        template: '<swb-shop-device-info :id="id" :showSingleTobObj="showSingleTobObj" ref="swb_trade_voucher_detail"></swb-shop-device-info>',
        data: {
            id: id,
            showSingleTobObj: showSingleTobObj
        },
    });
}

import SwbDevcRelatedPartList from './DevcRelatedPartList'
Vue.regist(SwbDevcRelatedPartList);
// 设备关联部件
export function showDevcRelatedPartListDlg(params) {
    let devcId = params["id"] || null;
    let repairFlag = Utils.isTrue(params["repairFlag"]);
    Vue.$showDialog({
        title: '设备部件',
        showCloseBtn: true,
        cancelText: '关闭',
        okVisible: false,
        width: -400,
        height: -100,
        template: '<swb-devc-related-part-list :devcId="devcId" :repairFlag="repairFlag" ref="swb_devc_related_part_list"></swb-devc-related-part-list>',
        data: {
            devcId: devcId,
            repairFlag: repairFlag
        }
    });
}

import SwbDevcRelatedPartSave from './DevcRelatedPartSave'
Vue.regist(SwbDevcRelatedPartSave);
// 设备部件保存
export function openDevcRelatedPartSaveDlg(params, callBack) {
    let id = params.id;
    let title = '设备部件 - 新增';
    let theDlg = Vue.$showDialog({
        title: title,
        width: 600,
        height: 500,
        showCloseBtn: true,
        template: '<swb-devc-related-part-save :id="id" ref="swb_devc_related_part_save"></swb-devc-related-part-save>',
        data: {
            id: id
        },
        okClicked: function () {
            let result = this.$refs.swb_devc_related_part_save.getDlgResult();
            if (result.type == "info") {
                callBack(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        lifecycle: {}
    });
}

import SwbShopDeviceListForSelect from './ShopDeviceListForSelect'
Vue.regist(SwbShopDeviceListForSelect);

/**
 *
 * @param dlgConfig 弹框参数
 * @param callback 回调函数
 * @param selfClose 是否需要调用者来控制弹框关闭
 */
export function showDevcSelectDlg(dlgConfig, callback, selfClose) {
    let title = dlgConfig["title"] || "选择资产";
    let filter = dlgConfig["filter"]; // 设备过滤条件
    let checkBox = dlgConfig["checkBox"];  // 是否多选，默认是
    let initSelectIds = dlgConfig["initSelectIds"] || []; // 多选-初始选中的ids(禁用)
    let checkedItem = dlgConfig["checkedItem"]; // 单选默认选中object
    let showOrgTree = dlgConfig["showOrgTree"] == null ? false : dlgConfig["showOrgTree"]; // 是否显示机构树
    let showMgmt = dlgConfig["showMgmt"] == null ? false : dlgConfig["showMgmt"];
    let bizDepart = dlgConfig["bizDepart"] == null ? false : dlgConfig["bizDepart"];
    let showIncludeSubComs = dlgConfig["showIncludeSubComs"] == null ? true : dlgConfig["showIncludeSubComs"]; // 显示组织机构及以下选项，默认显示
    let devcBizClolumType = dlgConfig["devcBizClolumType"] || 'DefDlg'; // 弹框类型（根据枚举devcBizClolumType）
    let useServcWork = dlgConfig["useServcWork"]; // 是否用于维保
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1300,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-shop-device-list-for-select :useServcWork="useServcWork" :devcBizClolumType="devcBizClolumType" :checkBox="checkBox" :showOrgTree="showOrgTree" :showMgmt="showMgmt" :showIncludeSubComs="showIncludeSubComs" :bizDepart="bizDepart" :filter="filter" :initSelectIds="initSelectIds" :checkedItem="checkedItem" ref="device_select_list"></swb-shop-device-list-for-select>',
        data: {
            filter: filter,
            checkBox: checkBox,
            initSelectIds: initSelectIds,
            checkedItem: checkedItem,
            showOrgTree: showOrgTree,
            showMgmt: showMgmt,
            showIncludeSubComs: showIncludeSubComs,
            bizDepart: bizDepart,
            devcBizClolumType: devcBizClolumType,
            useServcWork: useServcWork
        },
        okClicked: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            setTimeout(function () {
                let result = self.$refs.device_select_list.getDlgResult() || {};
                if (result.type === 'info') {
                    if (Utils.isNoB(selfClose) || !selfClose) {
                        callback(result.data);
                        theDlg.close();
                    } else {
                        callback(result.data, theDlg);
                    }
                } else {
                    MsgBox.warning(result.message);
                }
                theLoad.hide();
            }, 0);
            return false;
        }
    });
}

import SwbShopDeviceAssetList from './ShopDeviceAssetList';
Vue.regist(SwbShopDeviceAssetList);
// 资产台账列表
export function shopDeviceAssetListDlg(params) {
    let realComId = params['realComId'] || null;
    let onlyShowRealCom = params['onlyShowRealCom']; // 组织机构仅展示实体公司
    onlyShowRealCom = Utils.isNoB(onlyShowRealCom) ? null : Utils.isTrue(onlyShowRealCom);

    let onlyQueryDeprAsset = params['onlyQueryDeprAsset']; // 仅查询可折旧的资产
    onlyQueryDeprAsset = Utils.isNoB(onlyQueryDeprAsset) ? null : Utils.isTrue(onlyQueryDeprAsset);

    let deprable = params['deprable']; // 仅查询可折旧的资产
    deprable = Utils.isNoB(deprable) ? null : Utils.isTrue(deprable);
    let fiscalAbnormal = params['fiscalAbnormal']; // 财务异常

    let assetNature = params['assetNature'] || null; // 资产属性
    let currentMonth = params['currentMonth'] || null; // 当前月份
    let excludeCnt1stMonth = params['excludeCnt1stMonth']; // 排除首月不计提折旧的资产
    excludeCnt1stMonth = Utils.isNoB(excludeCnt1stMonth) ? null : Utils.isTrue(excludeCnt1stMonth);

    let unFilterAuthx = params['unFilterAuthx']; // 不过滤组织权限
    unFilterAuthx = Utils.isNoB(unFilterAuthx) ? null : Utils.isTrue(unFilterAuthx);

    let theDlg = Vue.$showDialog({
        title: "资产 - 台账",
        width: -200,
        height: -100,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-shop-device-asset-list :filterItem="filterItem" :onlyShowRealCom="onlyShowRealCom" :realComId="realComId" :tankuang="tankuang" ref="swb_assert_fiscal_info"></swb-shop-device-asset-list>',
        data: {
            filterItem: {
                retailerRealComId: realComId,
                onlyQueryDeprAsset: onlyQueryDeprAsset,
                deprable: deprable,
                fiscalAbnormalX: fiscalAbnormal,
                assetNature: assetNature,
                currentMonth: currentMonth,
                excludeCnt1stMonth: excludeCnt1stMonth,
                unFilterAuthx: unFilterAuthx
            },
            onlyShowRealCom: onlyShowRealCom,
            realComId: realComId,
            tankuang: true
        },
        methods: {},
        okClicked: function () {
        },
        onClosed: function () {
        }
    });
}

export function showTaskExportDlg(bizCode, tableData) {
    let scopeEntity = getUserScopeEntity();
    let asynTaskInfo = {};
    asynTaskInfo.ownerId = scopeEntity.id;
    asynTaskInfo.ownerType = scopeEntity.scopeId;
    asynTaskInfo.bizCode = bizCode;
    asynTaskInfo.paramInfo = JSON.encode(tableData);
    // 检查唯一键
    let self = this;
    let theLoad = MsgBox.loading();
    comnApi.getAsynTaskInfoByUk(asynTaskInfo, function (result) {
        theLoad.hide();
        if (result.type == 'info') {
            let data = result.data;
            if (data == null) {
                createTaskExportDlg(asynTaskInfo, function () {
                });
            } else {
                if (data.phase == 3 || data.phase == -1) {
                    MsgBox.confirm('已经创建了相同参数的任务【' + data.title + '】,确定要重新创建吗?', function () {
                        createTaskExportDlg(asynTaskInfo, function () {
                        });
                    });
                } else {
                    MsgBox.warning('已经创建了相同参数的任务【' + data.title + '】且正在进行中,无法重新创建');
                }
            }
        } else {
            self.$message.warning(result.message);
        }
    });
}

export function createTaskExportDlg(asynTaskInfo, callback) {
    let theDlg = Vue.$showDialog({
        title: "执行导出任务",
        width: 600,
        height: 300,
        showCloseBtn: true,
        template: '<div class="simple-form">' +
        '   <div class="form-group center">' +
        '        <div class="form-label">' +
        '            <label class="required">导出任务标题</label>' +
        '        </div>' +
        '        <div class="form-value width-2x">' +
        '            <el-input placeholder="请输入任务标题" v-model="title"></el-input>' +
        '        </div>' +
        '   </div>' +
        '   <div class="input-tip error">您所导出的数据较多，烦请您耐心等待，等待时间不影响您执行其他工作，系统处理完成会主动提醒您在“查看结果文件”下载！</div>' +
        '</div>',
        data: {
            title: null
        },
        okClicked: function () {
            let title = this.title;
            if (Utils.isNoB(title)) {
                Toast.show("请输入任务标题！");
                return false;
            } else {
                title = title.trim();
                if (title.length == 0) {
                    Toast.show("请输入任务标题！");
                    return false;
                } else if (title.length > 45) {
                    Toast.show("任务标题最长45个字符,现" + title.length + "个");
                    return false;
                }
            }
            this.title = title;
            asynTaskInfo.title = title;
            let theLoad = MsgBox.loading();
            comnApi.saveAsynTaskInfo(asynTaskInfo, function (result) {
                theLoad.hide();
                if (result.type === "info") {
                    theDlg.close();
                    callback();
                } else {
                    MsgBox.warning(result.message);
                }
            });
            return false;
        }
    });
}

import AsynTaskInfoList from './AsynTaskInfoList';
Vue.regist(AsynTaskInfoList);
export function viewTaskExportListDlg(params) {
    Vue.$showDialog({
        title: "查看结果文件",
        width: 1000,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-asyn-task-info-list :params="params"></swb-asyn-task-info-list>',
        data: {
            params: params
        }
    });
}

export function showTaskExportListDlg(bizCode) {
    let scopeEntity = getUserScopeEntity();
    let params = {};
    params.ownerId = scopeEntity.id;
    params.ownerType = scopeEntity.scopeId;
    params.bizCode = bizCode;
    Vue.$showDialog({
        title: "查看结果文件",
        width: 1000,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-asyn-task-info-list :params="params"></swb-asyn-task-info-list>',
        data: {
            params: params
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/devc/selectDlg.js
// module id = 29
// module chunks = 0